/**
 * Page Size Selector Component
 * Dropdown to select number of items per page
 */

import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';

interface PageSizeSelectorProps {
  value: number;
  options?: number[];
  onChange: (size: number) => void;
  disabled?: boolean;
  className?: string;
}

export function PageSizeSelector({
  value,
  options = [10, 25, 50, 100],
  onChange,
  disabled = false,
  className,
}: PageSizeSelectorProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className="text-sm text-muted-foreground whitespace-nowrap">Show:</span>
      <Select
        value={value.toString()}
        onValueChange={(val) => onChange(parseInt(val, 10))}
        disabled={disabled}
      >
        <SelectTrigger className="w-20 h-8">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option} value={option.toString()}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <span className="text-sm text-muted-foreground hidden sm:inline">per page</span>
    </div>
  );
}
